export default {
    title: 'Διατροφικό πλάνο',
    auto: 'Αυτόματη δημιουργία',
    previewMacros: 'Προεπισκόπηση μακροθρεπτικών',
    findDislikes: 'Εύρεση τροφίμων που δεν αρέσουν στον πελάτη',
    findDislikesDisclaimer: 'Η εύρεση δεν λειτουργεί με ακρίβεια και ενδέχεται να έχει εσφαλμένες ενδείξεις ή ελλείψεις.',
    recipes: 'Συνταγές διατροφικού πλάνου',
    share: 'Αποστολή με e-mail / Αποθήκευση ως PDF',
    searchFor: 'Αναζήτηση για',
    autoDesc: 'Αυτόματη δημιουργία διατροφικού πλάνου',
    system: 'Πρότυπο διατροφικό πλάνο του συστήματος, δεν μπορείτε να το επεξεργαστείτε. Αντιγράψτε το σε πελάτη ή σε νέο.',
    copyToTemplateTitle: 'Θέλετε σίγουρα να αποθηκεύσετε το πλάνο ως πρότυπο;',
    copyToTemplateText: 'Θα δημιουργηθεί ένα ακριβές αντίγραφο του διατροφικού πλάνου το οποίο μπορείτε να επεξεργαστείτε ξεχωριστά.',
    copyToAthleteTitle: 'Θέλετε σίγουρα να αντιγράψετε το διατροφικό πλάνο;',
    copyToAthleteText: 'Θα δημιουργηθεί ένα ακριβές αντίγραφο του διατροφικού πλάνου το οποίο μπορείτε να επεξεργαστείτε ξεχωριστά.',
    noCalories: {
        title: 'Δεν έχετε εισάγει τις θερμίδες και τα μακροθρεπτικά στοιχεία του πλάνου.',
        cta: 'Συμπληρώστε τις εξισώσεις ή εισάγετε χειροκίνητα!'
    },
    replaceCustomerFns: 'Αντικατάσταση ύψους/βάρους του πλάνου με του πελάτη;',
    addToCustomer: 'Προσθήκη σε πελάτη',
    pasteWithoutClear: 'Επικόλληση χωρίς εκκαθάριση',
    copyDay: 'Αντιγραφή ημέρας',
    pasteDay: 'Επικόλληση ημέρας',
    clearDay: 'Εκκαθάριση ημέρας',
    copyMealType: 'Αντιγραφή',
    pasteMealType: 'Επικόλληση',
    clearMealType: 'Εκκαθάριση',
    carbohydrationWarning: 'Έχετε ενεργοποιημένη την υδατανθράκωση!',
    ketosisWarning: 'Έχετε ενεργοποιημένη την κέτωση!',
    veganWarning: 'Έχετε ενεργοποιημένο vegan πλάνο!',
    fastingWarning: 'Έχετε ενεργοποιημένη τη νηστεία!',
    hideQuantitiesWarning: 'Έχετε ενεργοποιήσει την απόκρυψη ποσοτήτων. Οι ποσότητες θα είναι κρυφές στις εκτυπώσεις και στο mobile app.',
    copyToTable: 'Αντιγραφή (σε word, excel)',
    mealType: 'Τύπος γεύματος',
    insulinUnits: 'Μονάδες ινσουλίνης',
    recipeModal: {
        title: 'Λίστα συνταγών στο διατροφικό πλάνο',
        list: 'Λίστα συνταγών',
        empty: 'Δεν βρέθηκαν συνταγές σε αυτό το διατροφικό πλάνο!'
    },
    equations: {
        exerciseWarning: 'Οι θερμίδες δεν περιλαμβάνουν τα αθλήματα: είναι ο βασικός μεταβολισμός επί 1.2.',
        missingDetails: 'Για να υπολογιστούν οι θερμίδες, συμπλήρωσε: {fields}.',
        fieldNames: {
            sex: 'φύλο', age: 'ηλικία', height: 'ύψος', weight: 'βάρος', fat: 'λίπος',
            carbsPerKg: 'υδατάνθρακες ανά κιλό', proteinsPerKg: 'πρωτεΐνες ανά κιλό', fatsPerKg: 'λίπη ανά κιλό',
        },
        belowBmr: 'Οι θερμίδες είναι κάτω από τον βασικό μεταβολισμό ({bmr} kcal).',
        title: 'Εξισώσεις',
        bmr: 'Βασικός Μεταβολισμός (kcal)',
        kcal: 'Απαραίτητη ενέργεια (kcal)',
        exerciseLevels: {
            title: 'Επιλέξτε επίπεδο άσκησης',
            '13': '(1.00-1.39) Τυπικές καθημερινές δραστηριότητες (Οικιακά καθήκοντα, χαλαρό περπάτημα,\n' +
                '                  καθιστική εργασία)',
            '155': '(1.4-1.59) Χαμηλή δραστηριότητα, τυπικές καθημερινές δραστηριότητες και 30-60 λεπτά\n' +
                '                  καθημερινής μέτριας δραστηριότητας (περπάτημα με 5-7 χλμ. / Ώρα)',
            '17': '(1.6-1.89) Ενεργοί άνθρωποι, τυπικές καθημερινές δραστηριότητες συν 60 λεπτά\n' +
                '                  καθημερινής μέτριας δραστηριότητας',
            '19': '(1.9-2.5) Πολύ δραστήριοι, τυπικές καθημερινές δραστηριότητες συν τουλάχιστον 60\n' +
                '                  λεπτά καθημερινής μέτριας δραστηριότητας συν επιπλέον 60 λεπτά έντονης ή 120 λεπτά μέτριας\n' +
                '                  δραστηριότητας'
        },
        pal: {
            title: 'Χειροκίνητος συντελεστής PAL',
            range: 'Εύρος: από {from} έως {to}'

        },
        placeholder: {
            age: 'Εισάγετε την ηλικία του πελάτη',
            height: 'Εισάγετε το ύψος του πελάτη σε cm',
            weight: 'Εισάγετε το βάρους του πελάτη σε kg',
            fat: 'Εισάγετε το λίπος του πελάτη (π.χ. 10%)',
            fatPerKg: 'Λίπος ανά κιλό σωματικού βάρους',
            proteinsPerKg: 'Πρωτεϊνες ανά κιλό σωματικού βάρους',
            carbsPerKg: 'Υδατάνθρακες ανά κιλό σωματικού βάρους'
        },
        errors: {
            age: 'Η ηλικία πρέπει να είναι έγκυρη',
            height: 'Το ύψος πρέπει να είναι έγκυρο',
            weight: 'Το βάρος πρέπει να είναι έγκυρο',
            fat: 'Το λίπος πρέπει να είναι έγκυρο',
        },
        settings: {
            title: 'Ρυθμίσεις',
            manualKcal: 'Εισαγωγή θερμίδων χειροκίνητα;',
            advancedEq: 'Προχωρημένη εξίσωση; (χρήση αθλημάτων για υπολογισμό ενέργειας ανά ημέρα)',
            manualBmr: 'Εισαγωγή βασικού μεταβολισμού (BMR) χειροκίνητα;',
            exerciseFactor: 'Υπολογισμός θερμιδικών αναγκών με συντελεστή άθλησης',
        },
        goal: {
            title: 'Επιλέξτε στόχο',
            maintain: 'Συντήρηση',
            add: 'Μείωση βάρους',
            lose: 'Αύξηση βάρους',
            kgLose: 'Πόσα κιλά θέλετε να μειωθούν ανά μήνα;',
            kgAdd: 'Πόσα κιλά θέλετε να προστεθούν ανά μήνα;'
        },

        functions: {
            title: 'Επιλέξτε συνάρτηση',
            1: 'Harris & Benedict',
            2: 'Αναθεωρημένη Harris & Benedict',
            3: 'Owen',
            4: 'Mifflin',
            5: 'Katch-McArdle',
            6: 'Cunningham',
            7: 'FAO/WHO/UNU'
        }
    },
    macroTab: {
        title: 'Μακροθρεπτικά',
        daily: 'Ημερήσια κατανομή',
        dailyHint: 'Ποσοστό των θερμίδων της ημέρας.',
        perMeal: 'Στόχοι ανά γεύμα',
        perMealHint: 'Μοίρασε κάθε μακροθρεπτικό στα γεύματα, για στόχους ανά γεύμα στο πλάνο.',
        perKgUnit: 'g/kg',
        sum: 'Σύνολο',
        totalNot100: 'Το σύνολο είναι {total}%, πρέπει να είναι 100%.',
        mealsNot100: 'Κάθε μακροθρεπτικό πρέπει να μοιράζεται στα γεύματα ως 100%.',
        notANumber: 'Κάθε ποσοστό πρέπει να είναι αριθμός, 0 ή μεγαλύτερος.',
        keto: 'Κετογονική: λίπη ≥ 60%, υδατάνθρακες ≤ 10%.',
        ketoFats: 'Τουλάχιστον 60% σε κετογονική.',
        ketoCarbs: 'Έως 10% σε κετογονική.',
        fromPerKg: 'Υπολογίζονται από τα γραμμάρια ανά κιλό στις Εξισώσεις.',
        noKcal: 'Συμπλήρωσε τις θερμίδες στις Εξισώσεις για να δεις τα γραμμάρια.',
        track: 'Ενεργοποίηση παρακολούθησης μικροθρεπτικών;',
        choose: 'Επιλέξτε ποια μικροθρεπτικά θέλετε να παρακολουθείτε στο παράθυρο γεύματος.',
        general: 'Γενικά μικροθρεπτικά',
        generalShort: 'Γενικά',
        trixopoulou: 'Μικροθρεπτικά μόνο στη λίστα Τριχοπούλου',
        trixopoulouShort: 'Τριχοπούλου',
        usda: 'Μικροθρεπτικά μόνο στη λίστα USDA',
        usdaShort: 'USDA',
        selection: 'Επιλογή μικροθρεπτικών',
        goals: 'Στόχοι ημέρας',
        goal: 'Στόχος',
        noGoalsSet: 'Δεν έχουν οριστεί στόχοι ακόμα',
        noGoalsHint: 'Προσθέστε στόχους για τα μικροθρεπτικά που παρακολουθείτε.',
        disabledTitle: 'Η παρακολούθηση μικροθρεπτικών είναι ανενεργή',
        disabledSubtitle: 'Ενεργοποιήστε την παρακολούθηση για να επιλέξετε μικροθρεπτικά και να ορίσετε στόχους ημέρας.',
        enableTracking: 'Ενεργοποίηση παρακολούθησης',
        disableTracking: 'Απενεργοποίηση',
        addGoal: 'Προσθήκη Στόχου',
        nutrient: 'Μικροθρεπτικό',
        selectNutrient: 'Επιλογή Μικροθρεπτικού',
        chooseNutrient: 'Επιλέξτε μικροθρεπτικό...',
        goalKind: 'Τύπος',
        chooseKind: 'Επιλέξτε τύπο...',
        min: 'Ελάχιστο',
        max: 'Μέγιστο',
        between: 'Μεταξύ',
        value: 'Τιμή',
        fromTo: 'Από / Έως',
        from: 'Από',
        to: 'Έως',
        goalMet: 'Εντός στόχου',
        goalNotMet: 'Εκτός στόχου',
    },
    exerciseTab: {
        title: 'Άσκηση',
        warning: 'Για να επιλέξετε αθλήματα, πρέπει να έχετε ενεργοποιημένη την προχωρημένη εξίσωση.',
        warningCta: 'Αλλαγή ρυθμίσεων'
    },
    settingsTab: {
        title: 'Ρυθμίσεις'
    },
    analysisTab: {
        title: 'Ανάλυση'
    },
    notesTab: {
        insertToNotes: 'Εισαγωγή στις σημειώσεις',
        replaceWithTemplate: 'Αντικατάσταση σημειώσεων',
        intro: 'Γράψε σημειώσεις για το διατροφικό πλάνο που μπορείς να χρησιμοποιήσεις στην εκτύπωση',
        noTemplates: 'Δεν υπάρχουν πρότυπα σημειώσεων ακόμα',
        noTemplatesText: 'Φτιάξε πρότυπα στα «Πρότυπα σημειώσεων» του λογαριασμού σου.'
    },
    settings: {
        generalTitle: 'Γενικά',
        dietTypeTitle: 'Είδος διατροφής',
        mealsTitle: 'Γεύματα',
        optionsVsDays: 'Προβολή <strong>επιλογών</strong> αντί για ημέρες',
        mobileShare: 'Κοινοποίηση στην εφαρμογή κινητού',
        mobileShareNoClient: 'Διαθέσιμο μόνο σε πλάνα που ανήκουν σε πελάτη',
        allowMcpEdits: 'Επεξεργασία από AI',
        hideQuantities: 'Απόκρυψη ποσοτήτων',
        newFreeType: 'Ενεργοποίηση ελεύθερου πλάνου επιλογών',
        isVegan: 'Vegan διατροφολόγιο',
        isFasting: 'Νηστεία',
        isKeto: 'Κετογονική διατροφή',
        isInsulin: 'Ινσουλινοεξαρτώμενος διαβήτης',
        insulinRatio: 'Γράψε τα γραμμάρια υδατάνθρακα ανά μονάδα ινσουλίνης. Π.χ. για 1:15 γράψε 15',
        insulinRatioWarning: 'Μην ξεχάσεις να ρυθμίσεις την αναλογία ινσουλίνης:υδατάνθρακα. Συμβουλέψου τις οδηγίες του ιατρού του πελάτη σχετικά με την αναλογία. Περισσότερες πληροφορίες θα βρεις στις οδηγίες για διατροφολόγους του Pathisis.',
        carbohydration: 'Υδατανθράκωση',
        dayOfCarbohydration: 'Ημέρα υδατανθράκωσης',
        carbohydrationMissingWeight: 'Η υδατανθράκωση χρειάζεται το βάρος του πελάτη.',
        carbohydrationMissingWeightCta: 'Πρόσθεσέ το εδώ.',
        ketoSetup: 'Μην ξεχάσεις να ρυθμίσεις την κατανομή μακροθρεπτικών για την κέτωση',
        ketoSetupCta: 'στην καρτέλα Μακροθρεπτικά.',
    },
    attributes: 'Ιδιότητες',
    creation: {
        title: 'Τι είδους διατροφικό πλάνο θέλετε να δημιουργήσετε;',
        custom: {
            title: 'Εξατομικευμένο πλάνο',
            text: '(Διατροφικό πλάνο με εξισώσεις, τρόφιμα, αναλύσεις κ.λπ.)',
        },
        free: {
            title: 'Ελεύθερο πλάνο',
            text: '(Διατροφικό πλάνο μόνο με κείμενο)'
        }
    },

    mergeMeals: 'Συγχώνευση γευμάτων',
    unmergeMeals: 'Διαγραφή συγχώνευσης γευμάτων',
    stopMerging: 'Ακύρωση συγχώνευσης',
    reverseTable: 'Αντιστροφή πίνακα (ημέρες ως στήλες)',
    appearance: {
        title: 'Εμφάνιση',
        saveFailed: 'Δεν αποθηκεύτηκε η εμφάνιση. Δοκίμασε ξανά.',
        gridTheme: {
            label: 'Θέμα πίνακα',
            original: 'Κλασικό',
            refreshed: 'Ανανεωμένο',
            tinted: 'Απαλό',
        },
        quantityPosition: {
            label: 'Ποσότητα',
            inline: 'Δίπλα στο όνομα',
            right: 'Στα δεξιά',
        },
        categoryScheme: {
            label: 'Χρώματα κατηγοριών',
            classic: 'Κλασικά',
            deep: 'Πιο έντονα',
        },
        macroPreview: {
            label: 'Προεπισκόπηση μακροθρεπτικών',
            card: 'Κάρτα',
            compact: 'Συμπαγής',
        },
    },
    dayNotes: {
        menuLabel: 'Σημειώσεις ημέρας',
        deleteMenuLabel: 'Διαγραφή σημειώσεων ημέρας',
        modalTitle: 'Σημειώσεις ημέρας',
        placeholder: 'Γράψτε σημειώσεις για αυτή την ημέρα...',
        charLimit: '{count}/300 χαρακτήρες',
        unsavedTitle: 'Μη αποθηκευμένες αλλαγές',
        unsavedBody: 'Έχετε μη αποθηκευμένες αλλαγές. Θέλετε να τις απορρίψετε;',
        discardChanges: 'Απόρριψη',
    }
}
